import {LatLngModel} from './lat.lng.model';
import {MapLayerType} from './map-layer.model';

export class ConfigurationModel {
  readonly productName: string;
  readonly id: number;
  readonly customerName: string;
  readonly logoUrl: string;
  readonly driverSuffix: string;
  readonly additionalLayers: MapLayer[];
  readonly lookBackPeriod: number;
  readonly maxTrackHistoryHours: number;
  readonly region: LatLngModel[];
  readonly featureFlags: FeatureFlag[];
  readonly supervisorPermissions: string[];
  readonly useMetricSystem: boolean;
  readonly weatherLocation: Point;
  readonly geocodingService: GeocodingServiceModel;
  readonly contentVisibilityCutoff: Date;
  readonly otherSettings: OtherSettings;

  hasFeatureFlag(featureFlag: string): boolean {
    return !!this?.featureFlags.find(value => value.isEnabled && value.name === featureFlag);
  }
}

export class MapLayer {
  type: MapLayerType;
  id: number;
  name: string;
  url?: string;
  configuration?: string;
  routeConfigurationId?: number;
  tokenRequired: boolean;
  opacity?: number;
  useAsBaseMap?: boolean;

  // driven by settings
  checked = false;
}

export class FeatureFlag {
  readonly name: string;
  readonly label: string;
  readonly isEnabled: boolean;
}

export enum FeatureFlagEnum {
  CartegraphIntegration = 'cartegraph_integration',
  DashCam = 'dashcam',
  Poi = 'poi',
  ReportImage = 'report_image',
  Weather = 'weather',
  DeviceReport = 'report_device',
}

export class CartegraphFeatureFlag {
  readonly feature: string;
  readonly enabled: boolean;
}

export class PublicPortalSettings {
  titleColor?: string;
  titleBackgroundColor?: string;
  headline: Headline[];
  contentBlocks: ContentBlock[];
  logoLink: string;
  scrollingSpeed: number;
  showVehicleMarkers: boolean;
  showVehicleLabels: boolean;
  showMapContent: boolean;
  useMapThemes: boolean;
  allowGpsTracks: boolean;
  allowTimeMap: boolean;
  allowPassCountMap: boolean;
  allowRouteStatusMap: boolean;
  excludeVehicleGroupIds: number[];
  routeStatusLayerConfig: RouteStatusLayerConfig;
  hideLeftPanel: boolean;
  hideMessageBar: boolean;
}

export class RouteStatusLayerConfig {
  static THRESHOLD_VALUES: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 21, 24, 30, 36, 48, 72];

  routeConfigurationId: number;
  servicedThreshold: number;
}

export class Headline {
  text: string;
  selected?: boolean;
  color?: string;
  backgroundColor?: string;
}

export class ContentBlock {
  title: string;
  description?: string;
  selected: boolean;
  markdown: string;
}

export class Point {
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }
}

export class GeocodingServiceModel {
  url: string;
  srid?: number;
}

export class OtherSettings {
  messageTemplates: MessageTemplate[];
  stormStatus: StormStatus;
}

export class MessageTemplate {
  title: string;
  text?: string;
}

export class StormStatus {
  active: boolean;
  eventCreated?: Date;
}
